export const SET_GRADE_PRIMARIA = 'SET_GRADE_PRIMARIA'
export const SET_GRADE_SECUNDARIA = 'SET_GRADE_SECUNDARIA'
export const SET_GRADE_PRIMARIA_SELECIONADA_ID = 'SET_GRADE_PRIMARIA_SELECIONADA_ID'
export const SET_GRADE_SECUNDARIA_SELECIONADA_ID = 'SET_GRADE_SECUNDARIA_SELECIONADA_ID'
export const SET_QTD_ESTOQUE = 'SET_QTD_ESTOQUE'